var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"#f0f0f0"}},[_c('div',{staticClass:"footer"},[_c('span',[_vm._v("主管部门:"+_vm._s(_vm.cityDetail.cityName)+"农业农村局")]),_c('span',[_vm._v("监督部门:"+_vm._s(_vm.cityDetail.cityName)+"纪委监委")]),_c('span',[_vm._v("技术单位:河南晟宇信息技术有限公司")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }